import { render, staticRenderFns } from "./PresidentialLanding.vue?vue&type=template&id=1d7b903e&"
import script from "./PresidentialLanding.vue?vue&type=script&lang=js&"
export * from "./PresidentialLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports